import { featureFlagSettingsActionTypes } from 'actions/actionTypes';

const initialState = {
  isWePayIntergationEnabled: false,
  isWePayPaymentCollectionEnabled: true,
  isSortByAppointmentInTicketListEnabled: false
};

export default function featureFlagSettings(state = initialState, action) {
  switch (action.type) {
    case featureFlagSettingsActionTypes.FEATURE_FLAG_SETTINGS:
      return {
        ...state,
        isWePayIntergationEnabled: action.featureFlagSettings.isWePayIntergationEnabled,
        isWePayPaymentCollectionEnabled: action.featureFlagSettings.isWePayPaymentCollectionEnabled,
        isSortByAppointmentInTicketListEnabled: action.featureFlagSettings.isSortByAppointmentInTicketListEnabled,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/featureFlagSettingsReducer.js